export default "__VITE_ASSET__oiqAIe8t__"